import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

function Privacy() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length <= 1) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="btn-go-back" onClick={handleGoBack}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
          </svg>
          Close
        </button>
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: April 2026</p>

        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            NorCal Mobile Oil Change ("Company", "we", "us", or "our") respects your privacy and is committed to
            protecting your personal data. This Privacy Policy explains how we collect, use,
            disclose, and safeguard your information when you use our mobile oil change services
            or visit our website.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Information We Collect</h2>
          <p>We may collect the following types of information:</p>

          <h3>Personal Information</h3>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Service address</li>
            <li>Vehicle information (make, model, year, license plate)</li>
          </ul>

          <h3>Payment Information</h3>
          <ul>
            <li>We do not store credit card information</li>
            <li>Payments are processed through secure third-party payment processors</li>
          </ul>

          <h3>Automatically Collected Information</h3>
          <ul>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device information</li>
            <li>Usage data (pages visited, time spent)</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and manage our oil change services</li>
            <li>Process your bookings and payments</li>
            <li>Communicate with you about appointments and services</li>
            <li>Send service reminders and promotional offers (with your consent)</li>
            <li>Improve our services and customer experience</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Information Sharing</h2>
          <p>We do NOT sell your personal information. We may share your information with:</p>
          <ul>
            <li><strong>Service Providers:</strong> Third-party companies that help us operate our business
              (payment processors, scheduling software)</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational security measures to protect your
            personal information. However, no method of transmission over the Internet is 100% secure,
            and we cannot guarantee absolute security.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Data Retention</h2>
          <p>
            We retain your personal information for as long as necessary to fulfill the purposes
            outlined in this Privacy Policy, unless a longer retention period is required by law.
            Service records are kept for a minimum of 3 years for warranty and legal purposes.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Your Rights (California Residents)</h2>
          <p>Under the California Consumer Privacy Act (CCPA), you have the right to:</p>
          <ul>
            <li>Know what personal information we collect about you</li>
            <li>Request deletion of your personal information</li>
            <li>Opt-out of the sale of your personal information (we do not sell your data)</li>
            <li>Non-discrimination for exercising your privacy rights</li>
          </ul>
          <p>To exercise these rights, contact us using the information below.</p>
        </section>

        <section className="legal-section">
          <h2>8. Cookies and Tracking</h2>
          <p>
            Our website uses cookies and similar tracking technologies. When you first visit,
            a consent banner lets you accept or decline non-essential tracking.
          </p>

          <h3>Cookies We Use</h3>
          <ul>
            <li><strong>Essential:</strong> Cookie consent preference (stored in your browser's local storage)</li>
            <li><strong>Analytics (optional):</strong> Google Analytics (G-RECFGLLNT1) — measures page views and site performance</li>
            <li><strong>Advertising (optional):</strong> Google Ads (AW-18062345351) and Google Tag Manager — tracks ad conversions</li>
          </ul>

          <h3>Your Choices</h3>
          <p>
            If you decline cookies, we use Google Consent Mode to disable analytics and advertising
            data collection. You can also control cookies through your browser settings or clear
            your stored preferences at any time.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We are not responsible for the
            privacy practices of these external sites. We encourage you to read their privacy policies.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Children's Privacy</h2>
          <p>
            Our services are not directed to individuals under the age of 18. We do not knowingly
            collect personal information from children.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes
            by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </p>
        </section>

        <section className="legal-section contact-section">
          <h2>12. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us:</p>
          <ul>
            <li>Phone: <a
              href="tel:+19168188494"
              data-event="cta_call_click"
              data-cta-location="privacy_contact"
            >(916) 818-8494</a></li>
            <li>Email: <a href="mailto:info@norcalmobileoilchange.com">info@norcalmobileoilchange.com</a></li>
            <li>Location: Sacramento, California</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default Privacy;
